<template>
    <footer>
        <div class="footerWrapper container">
            <div class="footerBody">
                <router-link to="/"><img src="../assets/images/logo.svg" alt=""></router-link>
                <div>
                    <ul>
                        <li>About us
                            <ol>
                                <li>
                                    <p>Lorem ipsum dolor sit amet,
                                        consetetur sadipscing elitr,
                                        sed diam nonumy eirmod</p>
                                </li>
                                <li class="imagesGroup">
                                    <img src="../assets/images/icon_intagram.png" alt="">
                                    <img src="../assets/images/icon_facebook.png" alt="">
                                    <img src="../assets/images/icon_twich.png" alt="">
                                    <img src="../assets/images/icon_in.png" alt="">
                                    <img src="../assets/images/icon_youttube.png" alt="">
                                </li>
                            </ol>
                        </li>
                        <li>Important Links
                            <ol>
                                <li>
                                    <router-link to="/aboutUs">About us </router-link>
                                </li>
                                <li>
                                    <router-link to="/portafilo">Projects </router-link>
                                </li>
                                <li>
                                    <router-link to="/services">Services</router-link>
                                </li>
                                <li>
                                    <router-link to="/portafilo">Blog </router-link>
                                </li>
                                <li>
                                    <router-link to="/contact">Contact</router-link>
                                </li>
                            </ol>
                        </li>
                        <li class="FeaturedItem">Featured Services
                            <ol>
                                <li>
                                    <router-link to="/#services">IT Managment</router-link>
                                </li>
                                <li>
                                    <router-link to="/#services">Development</router-link>
                                </li>
                                <li>
                                    <router-link to="/#services">Services </router-link>
                                </li>
                                <li>
                                    <router-link to="/#services">UX/UI Design</router-link>
                                </li>
                                <li>
                                    <router-link to="/#services">Support Engineer</router-link>
                                </li>
                            </ol>
                        </li>
                        <li class="ContactItem">Contact
                            <ol class="contactList">
                                <li>
                                    <img width="30" height="30" src="../assets/images/icon_tell.png" alt="">
                                    <div>
                                        <h5>Phone </h5>
                                        <p>+998 94 658 26 97</p>
                                    </div>
                                </li>
                                <li>
                                    <img width="35" height="30" src="../assets/images/icon_message.png" alt="">
                                    <div>
                                        <h5>Email</h5>
                                        <p>info@pixyz.com</p>
                                    </div>
                                </li>
                                <li>
                                    <img width="25" height="33" src="../assets/images/icon_location.png" alt="">
                                    <div>
                                        <h5>Adress</h5>
                                        <p>Tashkent city, Uzbekistan, 100369</p>
                                    </div>
                                </li>
                            </ol>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="plicy container">
            <div class="">
                <p>Copyright @ 2020 PixYz. All Rights Reserved. Designed By Islom Usmonov</p>
                <a href="/">Terms & Conditions <span>|</span> Privacy Policy</a>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "FooterCompinent"
    }
</script>
<style scoped lang="scss">
    footer {
        background-color: #f4f6fc;
        margin-top: 88px;

        .footerWrapper {
            .footerBody {
                max-width: 90%;
                padding: 32px 0;
                margin: 0 auto;
                margin-left: 7.5%;
                a {
                    img {
                        width: 193px;
                        margin-bottom: 41px;
                        margin-left: 74px;
                    }
                }

                div {
                    margin-left: 9px;
                    margin-top: 5.3px;
                    ul {
                        display: flex;
                        flex-wrap: wrap;
                        margin: 0 auto;
                        margin-left: 65px;
                        li {
                            font-size: 23px;
                            color: #217a73;
                            padding-right: 139px;
                            margin-bottom: 20px;
                            font-weight: bolder;
                            letter-spacing: -0.3px;
                            ol {
                                margin-top: 21px;
                                li {
                                    padding: 0;
                                    margin: 4px 0;
                                    transition: all 0.5s;
                                    p {
                                        width: 210px;
                                        font-size: 16px;
                                        color: #8a8a8a;
                                        margin: 15px 0;
                                        margin-top: -2px!important;
                                        font-weight: 500;
                                        line-height: 24px;
                                    }

                                    img {
                                        margin: 8px 5px;
                                    }
                                    
                                    a {
                                        display: block;
                                        color: #000;
                                        transition: all 0.5s;
                                        font-weight: 500!important;
                                        font-family: "HelveticaNeueCyr";
                                        font-size: 16px;
                                        margin: 8px 0;
                                        margin-top: 12px;
                                    }
                                }
                                .imagesGroup {
                                    margin-left: -6px;
                                    img:hover {
                                        cursor: pointer;
                                    }
                                }
                                li:hover {
                                    a {
                                        color: #8a8a8a;
                                    }
                                }
                            }

                            .contactList {
                                margin-top: 14px;
                                margin-left: -5px;
                                li:nth-child(1) {
                                    padding: 0px 0;
                                    display: flex;
                                    margin-top: -2px;
                                    img {
                                        width: 31px;
                                        margin-left: 6px;
                                        height: 28.3px;
                                    }
                                    div {
                                        margin-left: 22px;
                                        margin-top: 10px;
                                        h5 {
                                            font-size: 16px;
                                            color: #000000;
                                            font-weight: 400;
                                        }
                                        p {
                                            font-size: 16px;
                                            color: #8a8a8a;
                                            margin: 0;
                                            padding-top: 14px;
                                            margin-left: -3px;
                                        }
                                    }
                                }
                                li:nth-child(2) {
                                    padding: 0px 0;
                                    display: flex;
                                    margin-top: -7px;
                                    img {
                                        width: 34px;
                                        height: 26px;
                                    }
                                    div {
                                        margin-left: 20px;
                                        margin-top: 10px;
                                        h5 {
                                            font-size: 16px;
                                            color: #000000;
                                            font-weight: 400;
                                        }
                                        p {
                                            font-size: 16px;
                                            color: #8a8a8a;
                                            margin: 0;
                                            padding-top: 12px;
                                            margin-left: -3px;
                                        }
                                    }
                                }
                                li:nth-child(3) {
                                    padding: 0px 0;
                                    display: flex;
                                    margin-top: -7px;
                                    img {
                                        width: 20px;
                                        height: 27.5px;
                                        margin-left: 12px;
                                    }
                                    div {
                                        margin-left: 27px;
                                        margin-top: 10px;
                                        h5 {
                                            font-size: 16px;
                                            color: #000000;
                                            font-weight: 400;
                                        }
                                        p {
                                            font-size: 16px;
                                            color: #8a8a8a;
                                            margin: 0;
                                            padding-top: 10px;
                                            margin-left: -3px;
                                            width: 250px;
                                        }
                                    }
                                }
                            }
                        }
                        .FeaturedItem {
                            margin-left: 30px;
                        }
                        .ContactItem {
                            margin-left: 35px;
                        }
                    }
                }
            }
        }

        .plicy {
            background-color: #fff;
            max-width: 140%;
            margin: 0 auto;
            margin-top: 13px;
            div {
                width: 74%;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;

                p {
                    font-size: 16px;
                    color: #8a8a8a;
                    padding: 9.5px 20px;
                }
                span {
                    margin-left: 6px;
                    margin-right: 8px;
                }
                a {
                    font-size: 16px;
                    color: #8a8a8a;
                    margin: auto 0;
                }
            }
        }
    }

    @media only screen and (max-width: 1900px) {
        footer {
            background-color: #f4f6fc;
            margin-top: 50px;

            .footerWrapper {
                .footerBody {
                    max-width: 100%;
                    padding: 20px 0;
                    margin: 0 auto;
                    a {
                        img {
                            width: 200px;
                            margin-bottom: 40px;
                            margin-left: 0px;
                        }
                    }

                    div {
                        ul {
                            display: flex;
                            flex-wrap: wrap;
                            justify-content: center;
                            margin: 0;
                            padding: 0;
                            li {
                                font-size: 22px;
                                color: #217a73;
                                padding-right: 70px;
                                margin-bottom: 20px;

                                ol {
                                    li {
                                        padding: 0;
                                        margin: 5px 0;

                                        p {
                                            max-width: 168px;
                                            font-size: 16px;
                                            color: #8a8a8a;
                                            margin: 20px 0;
                                        }

                                        img {
                                            margin: 0 2px;
                                        }

                                        a {
                                            color: #000;
                                            font-family: "comfortaa";
                                        }
                                    }
                                }

                                .contactList {
                                    li {
                                        padding: 5px 0;
                                        display: flex;

                                        div {
                                            margin-left: 10px;

                                            h5 {
                                                font-size: 16px;
                                                color: #000000;
                                                font-weight: 400;
                                            }

                                            p {
                                                font-size: 16px;
                                                color: #8a8a8a;
                                                padding: 5px 0;
                                                margin: 0;
                                            }
                                        }


                                    }

                                    li:nth-child(3) {
                                        div {
                                            margin-left: 20px !important;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .plicy {
                background-color: #fff;

                div {
                    padding: 0px;
                    display: flex;
                    justify-content: space-between;

                    p {
                        font-size: 16px;
                        color: #8a8a8a;
                    }

                    a {
                        font-size: 16px;
                        color: #8a8a8a;
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 1500px) {
       footer {
        background-color: #f4f6fc;
        margin-top: 82px;

        .footerWrapper {
            .footerBody {
                max-width: 100%;
                padding: 30px 0;
                margin: 0 auto;
                margin-left: 0%;
                a {
                    img {
                        width: 200px;
                        margin-bottom: 40px;
                        margin-left: 5px;
                    }
                }

                div {
                    margin-left: 0px;
                    margin-top: 8px;

                    ul {
                        display: flex;
                        flex-wrap: wrap;
                        margin: 0 auto;
                        margin-left: 0px;
                        li {
                            font-size: 22px;
                            color: #217a73;
                            padding-right: 50px;
                            margin-bottom: 20px;
                            font-weight: bolder;
                            ol {
                                li {
                                    padding: 0;
                                    margin: 5px 0;
                                    transition: all 0.5s;
                                    p {
                                        width: 210px;
                                        font-size: 16px;
                                        color: #8a8a8a;
                                        margin: 15px 0;
                                        font-weight: 500;
                                        line-height: 25px;
                                    }

                                    img {
                                        margin: 10px 5px;
                                    }
                                    .imagesGroup {
                                        margin-left: -10px;
                                    }
                                    a {
                                        display: block;
                                        color: #000;
                                        transition: all 0.5s;
                                        font-weight: 500!important;
                                        font-family: "comfortaa";
                                        font-size: 16px;
                                        margin: 13px 0;
                                    }
                                }

                                li:hover {
                                    a {
                                        color: #8a8a8a;
                                    }
                                }
                            }

                            .contactList {
                                margin-top: 12px;
                                li {
                                    padding: 0px 0;
                                    display: flex;
                                    div {
                                        margin-left: 12px;
                                        h5 {
                                            font-size: 16px;
                                            color: #000000;
                                            font-weight: 400;
                                        }

                                        p {
                                            padding: 1px;
                                            font-size: 16px;
                                            color: #8a8a8a;
                                            padding: 5px 0;
                                            margin: 0;
                                        }
                                    }


                                }

                                li:nth-child(3) {
                                    div {
                                        margin-left: 20px;
                                    }
                                }
                            }
                        }
                        .FeaturedItem {
                            margin-left: 30px;
                        }
                        .ContactItem {
                        margin-left: 35px;
                        }
                    }
                }
            }
        }

        .plicy {
            margin-top: -21px;
            background-color: #fff;
            width: 100%;
            div {
                padding: 0 0px;
                display: flex;
                justify-content: space-between;

                p {
                    font-size: 16px;
                    color: #8a8a8a;
                    padding: 10px 0;
                }

                a {
                    font-size: 16px;
                    color: #8a8a8a;
                    margin: auto 0;
                }
            }
        }
    }
    }
    @media only screen and (max-width: 1250px) {
       footer {
        background-color: #f4f6fc;
        margin-top: 82px;

        .footerWrapper {
            .footerBody {
                max-width: 100%;
                padding: 30px 0;
                margin: 0 auto;
                margin-left: 0%;
                a {
                    img {
                        width: 200px;
                        margin-bottom: 40px;
                        margin-left: 5px;
                    }
                }

                div {
                    margin-left: 0px;
                    margin-top: 8px;

                    ul {
                        display: flex;
                        flex-wrap: wrap;
                        margin: 0 auto;
                        margin-left: 0px;
                        li {
                            font-size: 16px;
                            color: #217a73;
                            padding-right: 20px;
                            margin-bottom: 20px;
                            font-weight: bolder;
                            ol {
                                li {
                                    padding: 0;
                                    margin: 5px 0;
                                    transition: all 0.5s;
                                    p {
                                        width: 210px;
                                        font-size: 14px;
                                        color: #8a8a8a;
                                        margin: 15px 0;
                                        font-weight: 500;
                                        line-height: 25px;
                                    }

                                    img {
                                        margin: 10px 2px;
                                    }
                                    .imagesGroup {
                                        margin-left: -10px;
                                    }
                                    a {
                                        display: block;
                                        color: #000;
                                        transition: all 0.5s;
                                        font-weight: 500!important;
                                        font-family: "comfortaa";
                                        font-size: 10px;
                                        margin: 10px 0;
                                    }
                                }

                                li:hover {
                                    a {
                                        color: #8a8a8a;
                                    }
                                }
                            }

                            .contactList {
                                margin-top: 12px;
                                li {
                                    padding: 0px 0;
                                    display: flex;
                                    div {
                                        margin-left: 12px;
                                        h5 {
                                            font-size: 16px;
                                            color: #000000;
                                            font-weight: 400;
                                        }

                                        p {
                                            padding: 1px;
                                            font-size: 16px;
                                            color: #8a8a8a;
                                            padding: 5px 0;
                                            margin: 0;
                                        }
                                    }


                                }

                                li:nth-child(3) {
                                    div {
                                        margin-left: 20px;
                                    }
                                }
                            }
                        }
                        .FeaturedItem {
                            margin-left: 30px;
                        }
                        .ContactItem {
                        margin-left: 35px;
                        }
                    }
                }
            }
        }

        .plicy {
            margin-top: -11px;
            background-color: #fff;
            width: 100%;
            div {
                padding: 0 0px;
                display: flex;
                justify-content: space-between;

                p {
                    font-size: 12px;
                    color: #8a8a8a;
                    padding: 10px 0;
                }

                a {
                    font-size: 12px;
                    color: #8a8a8a;
                    margin: auto 0;
                }
            }
        }
    } 
    }
    @media only screen and (max-width: 950px) {
        footer {
            background-color: #f4f6fc;
            margin-top: 50px;

            .footerWrapper {
                .footerBody {
                    max-width: 100%;
                    padding: 20px 0;
                    margin: 0 auto;

                    a {
                        img {
                            width: 150px;
                            margin-bottom: 40px;
                            margin-left: 20px;
                        }
                    }

                    div {
                        ul {
                            display: flex;
                            flex-wrap: wrap;
                            justify-content: space-around;

                            li {
                                font-size: 22px;
                                color: #217a73;
                                padding-right: 130px;
                                margin-bottom: 20px;
                                padding: 0;

                                ol {
                                    li {
                                        padding: 0;
                                        margin: 2px 0;

                                        p {
                                            max-width: 168px;
                                            font-size: 13px;
                                            color: #8a8a8a;
                                            margin: 20px 0;
                                        }

                                        img {
                                            margin: 0 2px;
                                        }

                                        a {
                                            color: #000;
                                            font-family: "comfortaa";
                                            font-size: 16px;
                                        }
                                    }
                                }

                                .contactList {
                                    li {
                                        padding: 5px 0;
                                        display: flex;

                                        img {
                                            width: 30px;
                                            height: 30px;
                                        }

                                        div {
                                            margin-left: 10px;

                                            h5 {
                                                font-size: 13px;
                                                color: #000000;
                                                font-weight: 400;
                                            }

                                            p {
                                                font-size: 13px;
                                                color: #8a8a8a;
                                                padding: 5px 0;
                                                margin: 0;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .plicy {
                background-color: #fff;

                div {
                    padding: 0px;
                    display: flex;
                    justify-content: space-between;

                    p {
                        font-size: 12px;
                        color: #8a8a8a;
                    }

                    a {
                        font-size: 12px;
                        color: #8a8a8a;
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 430px) {
        footer {
            background-color: #f4f6fc;
            margin-top: 50px;

            .footerWrapper {
                .footerBody {
                    max-width: 100%;
                    padding: 20px 0;
                    margin: 0 auto;

                    a {
                        img {
                            width: 150px;
                            margin-bottom: 0px;
                            margin-left: 30%;
                        }
                    }

                    div {
                        margin: 0 auto;

                        ul {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            margin: 0 auto;
                            padding: 0;
                            li {
                                margin-top: 0px;
                                text-align: center;
                                font-size: 14px;
                                color: #217a73;
                                padding-right: 0px;
                                margin-bottom: 20px;
                                padding: 0;
                                margin: 0;
                                margin-top: 30px;
                                margin-left: 0!important;
                                ol {
                                    padding: 0;
                                    margin: 0;
                                    margin-top: 10px;
                                    li {
                                        padding: 0;
                                        margin: 2px 0;

                                        p {
                                            max-width: 268px;
                                            font-size: 8px;
                                            line-height: 20px;
                                            color: #8a8a8a;
                                            margin: 20px auto;
                                        }

                                        img {
                                            margin: 0 2px;
                                            width: 20px;
                                        }

                                        a {
                                            color: #000;
                                            font-family: "comfortaa";
                                            font-size: 16px;
                                        }
                                    }
                                }

                                .contactList {
                                    margin-left: 18%;
                                    text-align: center;
                                    li {
                                        padding: 5px 0;
                                        display: flex;
                                        justify-content: center;
                                        margin: 0 auto;
                                        text-align: left;
                                        margin: 0 auto!important;
                                        img {
                                        display: none;}
                                        div {
                                            h5 {
                                                text-align: center;
                                                font-size: 13px;
                                                color: #000000;
                                                font-weight: 400;
                                            }

                                            p {
                                                font-size: 13px;
                                                color: #8a8a8a;
                                                padding: 5px 0;
                                                text-align: center;
                                                margin: 0;
                                            }
                                        }
                                    }

                                    li:nth-child(2) {
                                        img {
                                            width: 25px;
                                            height: 20px;
                                            margin: 0 auto;
                                            margin: 0;
                                        }
                                    }

                                    li:nth-child(1) {
                                        img {
                                            width: 20px;
                                            height: 20px;
                                            margin: 0 auto;
                                            margin: 0;
                                        }
                                    }

                                    li:nth-child(3) {
                                        img {
                                            width: 20px;
                                            height: 25px;
                                            margin: 0 auto;
                                            margin: 0;
                                        }
                                        div {
                                            margin-left: 0px!important;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .plicy {
                background-color: #fff;

                div {
                    padding: 0px;
                    display: flex;
                    justify-content: space-between;

                    p {
                        font-size: 4px!important;
                        color: #8a8a8a;
                    }

                    a {
                        display: none;
                        font-size: 4px!important;
                        color: #8a8a8a;
                    }
                }
            }
        }
    }
     @media only screen and (max-width: 340px) {
        footer {
            background-color: #f4f6fc;
            margin-top: 50px;

            .footerWrapper {
                .footerBody {
                    max-width: 100%;
                    padding: 20px 0;
                    margin: 0 auto;

                    a {
                        img {
                            width: 150px;
                            margin-bottom: 0px;
                            margin-left: 30%;
                        }
                    }

                    div {
                        margin: 0 auto;

                        ul {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            margin: 0 auto;
                            padding: 0;
                            li {
                                margin-top: 0px;
                                text-align: center;
                                font-size: 14px;
                                color: #217a73;
                                padding-right: 0px;
                                margin-bottom: 20px;
                                padding: 0;
                                margin: 0;
                                margin-top: 30px;
                                margin-left: 0!important;
                                ol {
                                    padding: 0;
                                    margin: 0;
                                    margin-top: 10px;
                                    li {
                                        padding: 0;
                                        margin: 2px 0;

                                        p {
                                            max-width: 268px;
                                            font-size: 8px;
                                            line-height: 20px;
                                            color: #8a8a8a;
                                            margin: 20px auto;
                                        }

                                        img {
                                            margin: 0 2px;
                                            width: 20px;
                                        }

                                        a {
                                            color: #000;
                                            font-family: "comfortaa";
                                            font-size: 16px;
                                        }
                                    }
                                }

                                .contactList {
                                    padding: 0;
                                    margin: 0;
                                    margin-left: 7%;
                                    text-align: center;
                                    li {
                                        padding: 5px 0;
                                        display: flex;
                                        justify-content: center;
                                        margin: 0 auto;
                                        text-align: left;
                                        margin: 0 auto!important;
                                        img {
                                        display: none;}
                                        div {
                                            h5 {
                                                text-align: center;
                                                font-size: 13px;
                                                color: #000000;
                                                font-weight: 400;
                                            }

                                            p {
                                                font-size: 13px;
                                                color: #8a8a8a;
                                                padding: 5px 0;
                                                text-align: center;
                                                margin: 0;
                                            }
                                        }
                                    }

                                    li:nth-child(2) {
                                        img {
                                            width: 25px;
                                            height: 20px;
                                            margin: 0 auto;
                                            margin: 0;
                                        }
                                    }

                                    li:nth-child(1) {
                                        img {
                                            width: 20px;
                                            height: 20px;
                                            margin: 0 auto;
                                            margin: 0;
                                        }
                                    }

                                    li:nth-child(3) {
                                        img {
                                            width: 20px;
                                            height: 25px;
                                            margin: 0 auto;
                                            margin: 0;
                                        }
                                        div {
                                            margin-left: 0px!important;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .plicy {
                background-color: #fff;

                div {
                    padding: 0px;
                    display: flex;
                    justify-content: space-between;

                    p {
                        font-size: 8px!important;
                        color: #8a8a8a;
                    }

                    a {
                        display: none;
                        font-size: 6px!important;
                        color: #8a8a8a;
                    }
                }
            }
        }
    }
</style>